/**
 * @generated SignedSource<<5d5c6aecb398c60923b0f053463587c9>>
 * @relayHash b7f13685547567cb79b9104935dfddf0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45cc764c8610f168265f189084eaf420bb8cc7cdaa6d3f678c6beeb06931b2ca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeploymentDetailsPopupQuery } from './DeploymentDetailsPopupQuery.graphql';

const node: PreloadableConcreteRequest<DeploymentDetailsPopupQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "45cc764c8610f168265f189084eaf420bb8cc7cdaa6d3f678c6beeb06931b2ca",
    "metadata": {},
    "name": "DeploymentDetailsPopupQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
